export default __webpack_public_path__ + "static/media/footer-blog.61509d16.svg";